import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { AppRoutes } from "navigations/app-routes";
import _ from "lodash";
import { stackProps } from "utils/helper-navigation";
import HelperString from "utils/helper-string";
import { createPageTitle } from 'utils/helper-page-title'
import ManagementEmailsIndexScene from 'scenes/management/emails'
import ManagementEmailsEditScene from 'scenes/management/emails/edit'
import ManagementAppMessagesIndexScene from 'scenes/management/app_messages'
import ManagementAppMessagesEditScene from 'scenes/management/app_messages/edit'

const Stack = createNativeStackNavigator();

const screens = {
	[AppRoutes.MANAGEMENT_APP_MESSAGES]: {
		component: ManagementAppMessagesIndexScene,
	},
	[AppRoutes.MANAGEMENT_APP_MESSAGES_EDIT]: {
		component: ManagementAppMessagesEditScene,
	},
}

const ManagementAppMessagesNavigator = ( props ) => {
	return (
		<Stack.Navigator
			{ ...stackProps }>

			{ _.map( screens, ( screen, name ) => {
				return (
					<Stack.Screen
						key={ HelperString.hash( `ManagementAppMessagesNavigator`, name ) }
						name={ name }
						options={{
							title: createPageTitle( _.get( screen, 'title', null ) )
						}}
						component={ screen.component }
					/>
				);
			})}
		</Stack.Navigator>
	);
};

export default ManagementAppMessagesNavigator
